module.exports = __webpack_public_path__ + "media/images/pages/commercial/pocstock-editorial-blacklivesmatter-1-4aeb39223700f3315ab84ebb54499985.png";